module.exports = __webpack_public_path__ + "static/img/wow.d2fc1305.png";